<script setup lang="ts">
import type { LoadingState } from "@/vf"
import { computed } from "vue"

const props = withDefaults(
    defineProps<{
        loading: boolean | LoadingState
        type?: "button" | "submit" | "reset"
        class?: string
        disabled?: boolean
    }>(),
    {
        type: "button",
        class: "btn btn-primary",
    },
)

const showSpinner = computed(() => {
    if (typeof props.loading === "boolean") {
        return props.loading
    }

    return props.loading.state
})
</script>
<template>
    <button :type="props.type" :class="props.class" :disabled="showSpinner || disabled">
        <span class="label" :class="showSpinner ? 'hidden' : ''">
            <slot></slot>
        </span>
        <span class="spinner" :class="showSpinner ? '' : 'hidden'">
            <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        </span>
    </button>
</template>

<style scoped>
button {
    display: grid;
    place-items: center;
    grid-template-areas: "button";
}

button span {
    grid-area: button;
}

button span.hidden {
    visibility: hidden;
}
</style>
